import gql from "graphql-tag";
import { buildFields } from "ra-data-hasura";
import { BuildFields, FetchType } from "ra-data-hasura";
import { ResourceType } from "../constants";

/**
 * Extracts just the fields from a GraphQL AST.
 * @param {GraphQL AST} queryAst
 */
const extractFieldsFromQuery = (queryAst: any) => {
  return queryAst.definitions[0].selectionSet.selections;
};

const GET_ONE_OR_LIST_CAMPAIGN = gql`
  {
    id
    name
    product_name
    budget_cash_usd_cents
    budget_pik_usd_cents
    brand_name
    description
    start_date
    end_date
    recruitment_end_date
    client_profile {
      id
      company_name
    }
    images {
      file_metadata {
        id
        url
        content_type
      }
    }
    tranches {
      min_follower_size
      max_follower_size
      number_kols
      cash_usd_cents
      product_value_usd_cents
      requirements
      product_categories {
        category_code
        product_category {
          name
        }
      }
      social_platforms {
        category_code
        social_platform {
          name
        }
      }
      genders {
        category_code
        gender {
          code
          description
        }
      }
      age_groups {
        category_code
        age_category {
          code
          name
        }
      }
      deliverable_specs {
        content_type {
          name
          code
        }
        quantity
        due_date
        requirement_description
        title
      }
    }
  }
`;

const GET_ONE_OR_LIST_KOL_PAYOUT = gql`
  {
    id
    kol_profile_id
    total_amount
    user_id
    wallet_id
    kol_profile {
      individual_fullname
    }
  }
`;

const GET_ONE_OR_LIST_CLIENT_PROFILE = gql`
  {
    address
    address2
    company_name
    country_code
    created_at
    description
    display_currency
    id
    is_active
    is_approved
    logo_file_id
    phone_number
    postal_code
    region
    region2
    updated_at
    user_id
    wallet_id
    wallet {
      id
      amount_usd_cents
    }
    logo_file {
      id
      url
    }
    client_survey {
      additional_info
      avg_budget_per_campaign_usd_cents
      avg_kols_per_campaign
      client_profile_id
      created_at
      display_currency
      id
      is_currently_running_campaigns
      number_of_campaigns_annually
      updated_at
    }
  }
`;

const GET_ONE_OR_LIST_KOL_PROFILE = gql`
  {
    id
    address
    name
    email
    contact
    state
    race
    gender
    language
    primary_category
    secondary_category
    platform
    co_no
    brand
    deliverables
    kol_rate
    status
    content_creativity
    posting_punctuality
    responsiveness
    overal_rating
    remarks
    created_at
    updated_at
    photo
    multipost
    ig_video
    ig_reels
    story
    youtube
    tiktok
    facebook
    xhs_photo
    xhs_video
    livestream
    photoshoot
    videoshoot
    event_attendance
  }
`;

export const UPDATE_ONE_KOL_PROFILE = gql`
  mutation update_kol_profile($id: uuid!, $bank_verification_status: String) {
    update_kol_profile(
      where: { id: { _eq: $id } }
      _set: { bank_verification_status: $bank_verification_status }
    ) {
      returning {
        id
      }
      affected_rows
    }
  }
`;

const GET_ONE_OR_LIST_AUDIT_LOG = gql`
  {
    id
    action_type
    action_by_user_id
    action_by_user_role
    target_id
    target_type
    addtionalInfo
    created_at
    user {
      email
    }
  }
`;

export const customBuildFields: BuildFields = (type, fetchType) => {
  const resourceName = type.name;

  console.info(`[customBuildFields][${resourceName}]`, { resourceName, type });

  if (
    resourceName === ResourceType.kol_payout &&
    [FetchType.GET_LIST, FetchType.GET_ONE].includes(fetchType as FetchType)
  ) {
    return extractFieldsFromQuery(GET_ONE_OR_LIST_KOL_PAYOUT);
  }

  if (
    resourceName === ResourceType.kol_profile &&
    [FetchType.GET_LIST, FetchType.GET_ONE].includes(fetchType as FetchType)
  ) {
    return extractFieldsFromQuery(GET_ONE_OR_LIST_KOL_PROFILE);
  }

  if (
    resourceName === ResourceType.kol_profile &&
    fetchType === FetchType.UPDATE
  ) {
    // TODO: This not working now, when used conjunction with, find out why
    // const { save, record } = useEditController({
    //   resource: "kol_profile",
    //   id: params.id,
    // });
    return extractFieldsFromQuery(UPDATE_ONE_KOL_PROFILE);
  }

  if (
    resourceName === ResourceType.client_profile &&
    [FetchType.GET_LIST, FetchType.GET_ONE].includes(fetchType as FetchType)
  ) {
    return extractFieldsFromQuery(GET_ONE_OR_LIST_CLIENT_PROFILE);
  }

  if (
    resourceName === ResourceType.campaign &&
    [FetchType.GET_LIST, FetchType.GET_ONE].includes(fetchType as FetchType)
  ) {
    return extractFieldsFromQuery(GET_ONE_OR_LIST_CAMPAIGN);
  }

  if (resourceName === ResourceType.audit_log &&
    [FetchType.GET_LIST, FetchType.GET_ONE].includes(fetchType as FetchType)
  ) {
    return extractFieldsFromQuery(GET_ONE_OR_LIST_AUDIT_LOG);
  }

  // No custom query defined, so use the default query fields (all, but no related/nested).
  return buildFields(type, fetchType);
};
